import angular from 'angular';
import uiModal from 'angular-ui-bootstrap/src/modal';

import {TipComponent} from './tip.component.js';
import FormComponent from './form/form.js';

const tip = angular.module('tip', [uiModal]);

tip.component('tip', TipComponent);
tip.component('tipkabineForm', FormComponent);

export {tip};



// WEBPACK FOOTER //
// ./app/components/tip/tip.js